//售中
import { apiAxios } from "@/api/axios";
import base from '../config'
let baseURL = base.baseURL
export default {
  //售中-可选问题类型
  typeList: (data) => apiAxios('post', baseURL + '/inSale.typeList', data),
  //售中-提出预览
  storePreview: (data) => apiAxios('post', baseURL + '/inSale.storePreview', data),
  //售中-提出
  inSaleStore: (data) => apiAxios('post', baseURL + '/inSale.store', data),
  //售中-取消
  inSaleCancel: (data) => apiAxios('post', baseURL + '/inSale.cancel', data),
  //售中-列表tab数
  listTabCount: (data) => apiAxios('post', baseURL + '/inSale.listTabCount ', data),
  //售中-列表
  inSaleList: (data) => apiAxios('post', baseURL + '/inSale.list', data),
  //售中-修改数量
  updateNewNum: (data) => apiAxios('post', baseURL + '/inSale.updateNewNum', data),
  //售中-修改option
  updateNewOption: (data) => apiAxios('post', baseURL + '/inSale.updateNewOption', data),
  //售中-待决策临时备注
  updateYDealRemark: (data) => apiAxios('post', baseURL + '/inSale.updateYDealRemark', data),
  //售中-待确认临时备注
  updatePDealRemark: (data) => apiAxios('post', baseURL + '/inSale.updatePDealRemark', data),
  //售中-新增赔款单关联
  addReparation: (data) => apiAxios('post', baseURL + '/inSale.addReparation', data),
  //售中-删除赔款单关联
  delReparation: (data) => apiAxios('post', baseURL + '/inSale.delReparation', data),
  //售中-业务决策
  yDeal: (data) => apiAxios('post', baseURL + '/inSale.yDeal', data),
  //售中-FBA/配货确认
  pDeal: (data) => apiAxios('post', baseURL + '/inSale.pDeal', data),
}